import UserVerificationModalContainer from '@perpay-web/fintech/components/containers/UserVerificationModalContainer';
import { useUserVerificationModalContext } from '@perpay-web/fintech/hooks/useUserVerificationModalContext';

const GlobalUserVerificationModalContainer = () => {
    const {
        isAnimatedModalOpen,
        setIsAnimatedModalOpen,
        animatedModalClassName,
    } = useUserVerificationModalContext();

    if (!isAnimatedModalOpen) {
        return null;
    }

    return (
        <UserVerificationModalContainer
            onClose={() => setIsAnimatedModalOpen(false)}
            className={animatedModalClassName}
        />
    );
};

export default GlobalUserVerificationModalContainer;
